import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { accessGroup as accessGroupConfig, goal as goalConfig, gridPage as gridPageConfig, notification as notificationConfig } from 'shared/api/query/configs.json';
import { accessPolicyType } from 'shared/constants.json';
import { getAccessTypeOfUser } from '@/lib/access-policy';

export default function usePostDenormalizeMiddlewares(postDenormalizeSvc, isPublishedView = false) {
  const { loggedInUser } = useLoggedInUser();

  // eslint-disable-next-line unused-imports/no-unused-vars
  const accessTypeMiddleware = (model) => (toDenormalize, dn, state, schema) => {
    Object.keys(toDenormalize).forEach((uid) => {
      if (dn.value[model][uid] === undefined) {
        return;
      }
      if (isPublishedView) {
        dn.value[model][uid].accessRight = accessPolicyType.read;
        return;
      }
      const { accessRight } = getAccessTypeOfUser(model)(dn.value[model][uid], loggedInUser.value, Object.values(dn.value.accessGroup));
      dn.value[model][uid].accessRight = accessRight;
    });
  };

  const accessGroupMiddleware = (toDenormalize, dn, state, schema) => {
    const models = [goalConfig.model, gridPageConfig.model];
    models.forEach((model) => {
      accessTypeMiddleware(model)(dn.value[model], dn, state, schema);
    });
  };

  const middlewares = [
    { model: goalConfig.model, fn: accessTypeMiddleware(goalConfig.model) },
    { model: gridPageConfig.model, fn: accessTypeMiddleware(gridPageConfig.model) },
    { model: notificationConfig.model, fn: accessTypeMiddleware(notificationConfig.model) },
    { model: accessGroupConfig.model, fn: accessGroupMiddleware },
  ];

  postDenormalizeSvc.setMiddlewares(middlewares);
}
